import type { VerificationStatus } from './types.ts';

/** Display order for status chips and filters: most reassuring first. */
export const STATUS_ORDER: VerificationStatus[] = [
  'confirmed',
  'date-mismatch',
  'found-no-date',
  'not-found',
  'unreachable',
  'unverified',
];
